import React from 'react'

export default function Footer() {
  return (
    <p className='footer-text'>&#169; 2023 Northlark PTE LTD</p>
  )
}
